import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './app/App';
import { ErrorBoundary } from './shared/ErrorBoundary';
import { installGlobalErrorHandlers, logError } from './shared/errorLog';

registerSW({ immediate: true });

// P0-5: глобальные перехватчики ошибок окна (window.onerror +
// unhandledrejection). Ставим до рендера, чтобы поймать и ранние падения.
installGlobalErrorHandlers();

try {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );
} catch (error) {
  console.error('[Bootstrap] React render failed:', error);
  // P0-5: само падение бутстрапа тоже логируем (best-effort).
  void logError({
    source: 'react',
    message: error instanceof Error ? error.message : 'Bootstrap render failed',
    stack: error instanceof Error ? error.stack ?? null : null,
    context: { phase: 'bootstrap' },
  });
}
